import React from 'react'
import {
  CONTAINER_STYLE,
  DIVIDER_SIZE,
  HEADING_TYPE,
  TEXT_SIZES,
} from '@helpers/constants'
import Container from '@components/Container'
import Heading from '@components/Heading'
import Divider from '@components/Divider'
// import Text from '@components/Text'

const FourOhFour = (props) => {
  return (
    <>
      <Container size={CONTAINER_STYLE.DESKTOP}>
        <div className={'flex justify-center'}>
          <Heading headingLevel={HEADING_TYPE.H1} size={TEXT_SIZES.XXXLARGE}>
            Sidan kunde inte hittas
          </Heading>
        </div>

        <Divider size={DIVIDER_SIZE.BASE} />

        {/* <div>
          <Text>404 innehåll här</Text>
        </div> */}
      </Container>
    </>
  )
}

export default FourOhFour
